(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PatchReport', PatchReport);

    PatchReport.$inject = ['$resource', 'DateUtils'];

    function PatchReport ($resource, DateUtils) {
        var resourceUrl =  'api/patch-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.issueDate = DateUtils.convertLocalDateFromServer(data.issueDate);
                        data.executedDate = DateUtils.convertDateTimeFromServer(data.executedDate);
                        data.approvalDate = DateUtils.convertDateTimeFromServer(data.approvalDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.issueDate = DateUtils.convertLocalDateToServer(data.issueDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.issueDate = DateUtils.convertLocalDateToServer(data.issueDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
